import React, { createContext, useState } from 'react';

export const IinContext = createContext();

export const IinProvider = ({ children }) => {
  const [iin, setIin] = useState('');
  const [userInfo, setUserInfo] = useState(null); 
  const [physPersonFullname, setPhysPersonFullname] = useState('');
  const [iinForBin, setIinForBin] = useState('');
  const [orgName, setOrgName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState(''); 
  const [bin, setBin] = useState(''); 
  const [iinOrBin, setIinOrBin] = useState('');

  return (
    <IinContext.Provider value={{  iin, setIin, userInfo, setUserInfo, physPersonFullname, setPhysPersonFullname, iinForBin, setIinForBin, orgName, setOrgName, firstName, setFirstName, lastName, setLastName, bin, setBin, iinOrBin, setIinOrBin }}>
      {children}
    </IinContext.Provider>
  );
};
